// Simple validation helpers replacing external validator dependency.
// Email regex: conservative pattern permitting common local parts and domain TLDs >=2 chars.
const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

export function isEmail(value) {
  if (!value || typeof value !== 'string') return false;
  if (value.length > 254) return false; // RFC limit
  return emailRegex.test(value.trim());
}

export function isNonNegativeInt(value) {
  if (value === undefined || value === null) return false;
  if (typeof value === 'number') return Number.isInteger(value) && value >= 0;
  if (typeof value === 'string') {
    if (!/^\d+$/.test(value)) return false;
    // Prevent leading zeros overflow? Accept them since parseInt handles it.
    const num = Number(value);
    return Number.isInteger(num) && num >= 0;
  }
  return false;
}

export function isNonNegativeDecimal(value, maxDecimals = 2) {
  if (value === undefined || value === null) return false;
  const pattern = new RegExp(`^\\d+(?:\\.\\d{1,${maxDecimals}})?$`);

  if (typeof value === 'number') {
    if (!Number.isFinite(value) || value < 0) return false;
    return pattern.test(String(value));
  }

  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (trimmed.length === 0) return false;
    if (!pattern.test(trimmed)) return false;
    const num = Number(trimmed);
    return Number.isFinite(num) && num >= 0;
  }

  return false;
}

export default { isEmail, isNonNegativeInt, isNonNegativeDecimal };
